export const TruliaIcon = ({ className = "h-6 w-6" }: { className?: string }) => {
  return (
    <svg
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="m50 0-50 45v55h100v-55zm-19.45 80h-11.1v-20h11.1z"
        fill="#02ADBA"
      />
    </svg>
  );
};
